module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agent"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("待处理")]), _vm._v(" "), (_vm.openWxMsgRemid == "Y") ? _c('div', {
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("关闭提醒")]) : _vm._e(), _vm._v(" "), (_vm.openWxMsgRemid == "N") ? _c('div', {
    staticClass: "div",
    on: {
      "click": _vm.changeStatu
    }
  }, [_vm._v("开启提醒")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "tips",
    attrs: {
      "infinite-scroll-distance": "20",
      "infinite-scroll-delay": "500"
    }
  }, _vm._l((_vm.agentList), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "user-submit"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "project-name"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "submit-time"
    }, [_c('span', {
      staticClass: "status"
    }), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.initiateTime))])])])
  }), 0), _vm._v(" "), _c('Nav', {
    ref: "nav",
    attrs: {
      "navIndex": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-472bac21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/agent.vue
// module id = 1665
// module chunks = 471